import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useAxiosInstance } from 'src/utils/useAxiosInstance';

export function useMovementDetail(orderId) {
  const { axiosInstance } = useAxiosInstance();

	return useQuery({
		queryKey: ['movements', orderId],
		queryFn: async () => {
			// return mockMovementsListRes.transferOrder.find(item => item.orderId === orderId);
			const { data } = await axiosInstance.get(
        `/consignment-transfer-order/${orderId}`
      );
			return data.data;
		},
	})
}

export function useMovementsList({ pageDetail, searchText }) {
  const { axiosInstance } = useAxiosInstance();

  const sortBy = {
    No: pageDetail.Status === 'Completed' ? 'transferReceiptId' : 'orderId',
    Posting_Date: 'postingDate',
  };

  const status = {
    Pending: 'Open',
    'In Progress': 'In-progress',
    Acknowledgements: 'Acknowledged',
    Completed: 'Completed',
  };

  const queryParams = {
    limit: pageDetail.Limit,
    page: pageDetail.Page,
    sortBy: sortBy[pageDetail.SortBy],
    sortOrder: pageDetail.SortOrder,
    search: searchText,
    status: status[pageDetail.Status],
  };
  const queryString = new URLSearchParams(queryParams).toString();

	return useQuery({
		queryKey: ['movements', pageDetail, searchText],
		queryFn: async () => {
			// return mockMovementsListRes;
			const { data } = await axiosInstance.get(
        `/consignment-transfer-order?${queryString}`
      );
			return data;
		},
	})
}

export function useAcceptMovement() {
  const { axiosInstance } = useAxiosInstance();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ orderId, customerName }) => {
      const { data } = await axiosInstance.post(
        `/consignment-transfer-order/${orderId}`,
        { customerName }
      );
      return data;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries(['movements', variables.orderId]);
      return queryClient.invalidateQueries(['movements']);
    }
  })
}
